module.exports = __webpack_public_path__ + "media/images/pc/stores/common/appeal_02-19a493adbd6b5b2c3b45f814d600022b.jpg";